import { baseUrl } from '../requestPub/api.js';
import { useLoginStore } from '../stores/login.js';
import { useUserStore } from '../stores/user.js';
import { base64ToFile } from './base64.js';
import voicequeue from './queue.js';
import messagetips from '../static/systemVioce/messagetips.mp3';
import { addData, getData } from './db';
import nativePlugin from './nativePlugin.js';
const backgroundVoice = uni.createInnerAudioContext();
backgroundVoice.sessionCategory = 'ambient';
const backTextAudio = uni.createInnerAudioContext();
backTextAudio.sessionCategory = 'ambient';

export const playTextVoice = (text) => {
    if (uni?.requireNativePlugin) {
        nativePlugin.voice.playVoice(text);
        return;
    }
    const hastext_video = uni.getStorageSync(text);
    if (!hastext_video) {
        console.log('我要去获取音频');
        requestVoice(text);
    }
    voicequeue.enqueue(text);
    if (voicequeue.length == 1) {
        playVoice(text);
    }
};
const requestVoice = (msg) => {
    const token = useLoginStore().loginToken;
    if (!token) {
        voicequeue.dequeue();
        return;
    }
    uni.request({
        url: baseUrl + '/_hotel/text2audio',
        header: {
            Authorization: token,
            Channel: 'cashier'
        },
        responseType: 'arraybuffer',
        method: 'POST',
        data: {
            tex: msg,
            cuid: ('uni_casher_' + new Date().getTime() + Math.random() * 1000).split('.')[0],
            ctp: '1',
            lan: 'zh',
            spd: '5',
            pit: '4',
            vol: '5',
            per: '4146', //0 杜小梅  111 杜晓萌
            aue: '3'
        },
        success(res) {
            console.log('请求成功', res);
            const data = res.data;

            if (data) {
                // #ifdef APP
                blobToBase64(data, msg);
                // #endif

                // #ifdef H5
                playVoiceWeb(msg, data);
                // #endif
            }
        },
        fail() {
            voicequeue.dequeue();
        }
    });
};
let src_name = '';
const blobToBase64 = (arrayBuffer, name) => {
    const base64 = uni.arrayBufferToBase64(arrayBuffer);
    base64ToFile(base64, name + '.mp3', (e) => {
        console.log(name, e);
        uni.setStorageSync(name, e);
        src_name = name;
        const userStore = useUserStore();
        backTextAudio.volume = userStore?.userInfo?.config?.volume || 1;
        backTextAudio.src = e;
        backTextAudio.play();
    });
};
const playVoiceWeb = async (currentmsg, res) => {
    const isNvue = getApp()?.globalData?.platform?.nvue;
    const info_url = await getData(currentmsg);
    if (!info_url) {
        addData({ msg: currentmsg, voice: res });
    }
    const blob = new Blob([res]); // 根据音频格式修改MIME类型
    const url = URL.createObjectURL(blob);
    try {
        if (isNvue) {
            uni.webView?.postMessage?.({
                data: {
                    action: 'playVoice',
                    type: 'get-cookie', //因通信场景可能很多，可以通过这个字段标记所发送的消息类型，便于uni-app接收和处理
                    value: currentmsg, //当次消息所传递的值,
                    http_url: baseUrl + '/_hotel/text2audio',
                    token: useLoginStore().loginToken || ''
                }
            });
            URL.revokeObjectURL(url); // nvue 分支未使用 url，在此直接释放防止内存泄漏
        } else {
            playItem(url);
        }
    } catch {
        playItem(url);
    }
};
export const createAudio = async () => {
    // cutLine = isCutLine;

    // currentmsg = msg;
    // 店铺配置
    const userStore = useUserStore();
    backTextAudio.volume = userStore?.userInfo?.config?.volume || 1;
    backTextAudio.play().catch((error) => {
        console.log('播放出错，删除队列4', JSON.stringify(error));
        if (!voicequeue.isEmpty()) {
            voicequeue.dequeue();
            const next_audio = voicequeue.getFirst();
            if (next_audio) {
                createAudio(next_audio);
            }
        }
    });
};
function playItem(url) {
    try {
        // 如果当前有音频在播放，则停止它
        console.log('播放文案2->', url);
        let currentAudio = new Audio(url);
        const userStore = useUserStore();
        currentAudio.volume = userStore?.userInfo?.config?.volume || 1;
        currentAudio.play().catch((error) => {
            console.error('音频播放失败', error);
            currentAudio.removeEventListener('ended', () => {});
            currentAudio = null;
            URL.revokeObjectURL(url); // 播放失败释放对象URL

            if (!voicequeue.isEmpty()) {
                voicequeue.dequeue();
                const next_audio = voicequeue.getFirst();
                console.log(next_audio);
                if (next_audio) {
                    createAudio(next_audio);
                }
            }
        });
        currentAudio.addEventListener('ended', () => {
            currentAudio.removeEventListener('ended', () => {});
            currentAudio = null;
            URL.revokeObjectURL(url); // 播放结束释放对象URL

            if (!voicequeue.isEmpty()) {
                voicequeue.dequeue();
                const next_audio = voicequeue.getFirst();
                if (next_audio) {
                    createAudio(next_audio);
                }
            }
        });

        // 释放对象URL（可选）
    } catch (error) {
        URL.revokeObjectURL(url); // 出现异常释放对象URL
        if (!voicequeue.isEmpty()) {
            console.log('播放出错，删除队列', error);
            voicequeue.dequeue();
            const next_audio = voicequeue.getFirst();
            if (next_audio) {
                createAudio(next_audio);
            }
        }
    }
}
const playVoice = () => {
    const userStore = useUserStore();
    // 音量设置
    backgroundVoice.volume = userStore?.userInfo?.config?.volume || 1;
    backgroundVoice.src = messagetips;
    backgroundVoice.play();
};

backgroundVoice.onEnded(() => {
    const text = voicequeue.getFirst();
    src_name = text;
    const url = uni.getStorageSync(text);
    if (url) {
        const { config } = useUserStore().userInfo;
        backTextAudio.volume = config.volume || 1;
        backTextAudio.src = url;
        backTextAudio.play();
    } else {
        voicequeue.dequeue();
        if (!voicequeue.isEmpty()) {
            console.log('开始播放下一个');
            playVoice();
        }
    }
});
backgroundVoice.onError(() => {
    console.log('播放出错');
    voicequeue.dequeue();
    if (!voicequeue.isEmpty()) {
        playVoice();
    }
});

backTextAudio.onError(() => {
    uni.removeStorageSync(src_name);
    console.log('文字语音错误');
    voicequeue.dequeue();
    if (!voicequeue.isEmpty()) {
        console.log('开始播放下一个');
        playVoice();
    }
});
backTextAudio.onEnded(() => {
    voicequeue.dequeue();
    if (!voicequeue.isEmpty()) {
        playVoice();
    }
});

export const insertPauseMark = (str) => {
    str = str.toString().toUpperCase();
    // 匹配中文与中文、中文与字母数字之间的位置
    // 处理连续字母数字（纯字母/纯数字）
    str = str.replace(/([0-9])(?=[0-9a-zA-Z])|([a-zA-Z])(?=[0-9a-zA-Z])/g, '$1$2、');
    // 处理中文与字母数字交界
    const info = str.replace(/([\u4E00-\u9FA5])(?=[0-9a-zA-Z])|([0-9a-zA-Z])(?=[\u4E00-\u9FA5])/g, '$1$2、');

    return info.replace('间', '间(jian1)');
};
